const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Görsel yükleme: dosyayı /api/images'e yükler ve "/api/images/{id}" yolunu döner.
// Görsel sunucuda otomatik olarak WebP'ye dönüştürülüp 1 MB altına sıkıştırılır;
// bu yüzden kullanıcı tarafında boyut sınırı yok (yalnızca makul bir üst sınır var).
// Görseller veritabanında BLOB olarak saklanır (her ortamda çalışır, deploy'dan bağımsız).
export const MAX_UPLOAD_SIZE = 20 * 1024 * 1024; // 20 MB (güvenlik üst sınırı)

// Sunucunun çözebildiği (ImageSharp) formatlar. HEIC/HEIF desteklenmez.
const UNSUPPORTED_HINT = /heic|heif/i;

export const uploadImage = async (file) => {
  if (!file) {
    throw new Error('Dosya seçilmedi.');
  }
  if (file.type && !file.type.startsWith('image/')) {
    throw new Error('Lütfen bir görsel dosyası seçin.');
  }
  if (UNSUPPORTED_HINT.test(file.type) || UNSUPPORTED_HINT.test(file.name)) {
    throw new Error('Bu format (iPhone HEIC) desteklenmiyor. Lütfen JPG, PNG, WEBP veya GIF yükleyin.');
  }
  if (file.size > MAX_UPLOAD_SIZE) {
    throw new Error('Görsel çok büyük. En fazla 20 MB yükleyebilirsiniz.');
  }

  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('file', file);

  const endpoint = `${API_BASE_URL}/api/images`;

  let response;
  try {
    response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
  } catch (netErr) {
    throw new Error(`Sunucuya bağlanılamadı. Backend çalışıyor mu? Detay: ${netErr.message}`);
  }

  if (!response.ok) {
    let message = `Görsel yüklenemedi (HTTP ${response.status}).`;
    try {
      const err = await response.json();
      if (err && err.message) message = err.message;
    } catch (_) { /* yoksay */ }
    throw new Error(message);
  }

  const data = await response.json();
  return data.url; // "/api/images/{id}"
};
